import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import AnimatedSection from "../common/AnimatedSection";

const KeyHighlights = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [testimonials, setTestimonials] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const testimonialSlider = useRef(null);
  const [galleryFilter, setGalleryFilter] = useState("all");
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImage, setLightboxImage] = useState({});
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [activeClientCategory, setActiveClientCategory] = useState("showroom");
  const [currentLogoIndex, setCurrentLogoIndex] = useState(0);

  // Automatic testimonial sliding

  const clientCategories = [
    { id: "showroom", name: "Showroom", icon: "fas fa-store" },
    { id: "hospitality", name: "Hospitality", icon: "fas fa-hotel" },
    { id: "industry", name: "Industry", icon: "fas fa-industry" },
    { id: "hospital", name: "Hospital", icon: "fas fa-hospital" },
    // { id: "complex", name: "Complex", icon: "fas fa-building" },
    { id: "other", name: "Other", icon: "fas fa-ellipsis-h" },
  ];

  // Client data organized by category
  const clientsData = {
    showroom: [
      {
        name: "LDJ",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753205853/LDJ_-agra_veg2xi.jpg",
        location: "Agra",
      },
      {
        name: "Samruddhi Jewellers",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753205852/samruddhi_jwellers-_mathura_jdevvf.jpg",
        location: "Mathura",
      },
      {
        name: "Shree Jewellers",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753205851/Shree_jewellers-_agra_yhnbbm.jpg",
        location: "Agra",
      },
      {
        name: "Maadhav Ceramic",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753205850/MaadhavCeramic-agra_gjdush.jpg",
        location: "Agra",
      },
      {
        name: "Unique Lite Fernitures",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753205849/UniqueLitesFerniture-agra_krcc1q.jpg",
        location: "Agra",
      },
      {
        name: "Roop Sons",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753205848/RoopSons-agra_h8gty9.jpg",
        location: "Agra",
      },
      {
        name: "RK Marketing",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753205844/RKMarketing-agra_t2gk0l.jpg",
        location: "Agra",
      },
      {
        name: "PLY Bank",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753205847/PLYBank-agra_qzmlxo.png",
        location: "Agra",
      },
      {
        name: "Womens Plaza",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753205846/WomensPlaza-agra_pelmng.jpg",
        location: "Agra",
      },
      {
        name: "Royal Enfield Showroom",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753205845/royal-enfield-showroom-aryaman-enterprises-mathura-mathura-logo_gpymlf.png",
        location: "Mathura",
      },
      {
        name: "Veneer World",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753205843/VeneerWorld-agra_g059qb.jpg",
        location: "Agra",
      },
      {
        name: "Dinesh Jewellers",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753205843/DineshJewelers-aligarh_kgbo2m.png",
        location: "Aligarh",
      },
    ],
    hospitality: [
      {
        name: "Radisson Vrindavan",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753221898/radisson-vrindavan_eqcw1n.png",
        location: "Vrindavan",
      },
      {
        name: "Howard Plaza",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753221897/HowardPlaza-agra_zu9yjj.jpg",
        location: "Agra",
      },
      {
        name: "Deepee Restaurant",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753221896/Deepee-agra_tenjjy.jpg",
        location: "Agra",
      },
      {
        name: "Gopal Das Pethe Wale",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753221894/GopaldasPetheWale-agra_tcnzwq.jpg",
        location: "Agra",
      },
      {
        name: "Clarks Inn Express",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753221893/Clarks_inn_Express-firozabad_dzfuzc.avif",
        location: "Firozabad",
      },
      {
        name: "The Numberdaars",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753221891/The_Numberdars-agra_ptfbzl.jpg",
        location: "Agra",
      },
      {
        name: "Rathee Atithi",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753221901/ratheeAtithi-vrindavan_ha6cyg.jpg",
        location: "Vrindavan",
      },
    ],
    industry: [
      {
        name: "Stoneman",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753221886/Stonemen_-_agra_w8ndzk.jpg",
        location: "Agra",
      },
      {
        name: "Bandejjia Traders",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753221884/Bandejjia_Traders_-_Agra_owcs7r.avif",
        location: "Agra",
      },
      {
        name: "Best Western",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753221883/best_western-_vrindavan_sp90vv.avif",
        location: "Vrindavan",
      },
      {
        name: "Romsons",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753221881/Romsons-Agra_iqnmyd.png",
        location: "Agra",
      },
      {
        name: "R N Bajaj Overseas",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753221880/RN_Bajaj_Overseas_-_agra_mpthfq.png",
        location: "Agra",
      },
      {
        name: "Virola International",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753221879/Virola_international_-_Agra_qdlqhi.jpg",
        location: "Agra",
      },
    ],
    hospital: [
      {
        name: "G G Medical",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753222245/G_G_Medical_-_agra_besrov.png",
        location: "Agra",
      },
      {
        name: "Ramved Hospital",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753222246/ramved-hospital-new-agra-agra-hospitals-_eb3rna.png",
        location: "Agra",
      },
      {
        name: "Ujala Cygnus Rainbow Hospital",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753222248/Ujala_cygnus_rainbow_hospital-_agra_bko56r.png",
        location: "Agra",
      },
      {
        name: "Rashmi Medecine",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753222251/Rashmi_medecine-_agra_gm4at5.png",
        location: "Agra",
      },
    ],
    // complex: [
    //   { name: "", logo: "", location: "" },
    // ],
    other: [
      {
        name: "City Palace",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753222089/CityPalace-Udaypur_hblakw.jpg",
        location: "Udaipur",
      },
      {
        name: "GuruDwara",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753222086/GuruDwara-agra_jdywlq.jpg",
        location: "Agra",
      },
      {
        name: "Agra Club",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753222084/Agra_Club_v0l2n8.png",
        location: "Agra",
      },
      {
        name: "Reliance Smart Bazar",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753221809/reliance-smart-point-mathura_ciz3yl.avif",
        location: "Mathura",
      },
      {
        name: "Orchid Green",
        logo: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753221807/OrchidGreen-firozabad_r9nzro.jpg",
        location: "Firozabad",
      },
    ],
  };

  // Helper functions
  const getCurrentClients = () => {
    return clientsData[activeClientCategory] || [];
  };

  const getVisibleLogosCount = () => {
    if (windowWidth <= 576) return 1;
    if (windowWidth <= 820) return 2;
    if (windowWidth <= 1024) return 3;
    return 4;
  };

  // Auto-rotate logos
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentLogoIndex((prev) => {
        const maxIndex = getCurrentClients().length - getVisibleLogosCount();
        return prev >= maxIndex ? 0 : prev + 1;
      });
    }, 3000);

    return () => clearInterval(interval);
  }, [activeClientCategory, windowWidth]);

  // Reset logo index when category changes
  useEffect(() => {
    setCurrentLogoIndex(0);
  }, [activeClientCategory]);

  useEffect(() => {
    const script = document.createElement("script");
    // Use the official production URL
    script.src = "https://widgets.sociablekit.com/google-reviews/widget.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const getResponsiveStyles = () => {
    // Define breakpoints
    const isMobile = windowWidth <= 576;
    const isTablet = windowWidth <= 820 && windowWidth > 576;

    return {
      clientsSection: {
        padding: isMobile ? "50px 0" : isTablet ? "70px 0" : "90px 0",
        backgroundColor: "#f1f5f9",
        backgroundImage:
          "radial-gradient(circle at 90% 10%, rgba(22, 59, 162, 0.05) 0%, rgba(22, 59, 162, 0) 50%)",
        position: "relative",
        overflow: "hidden",
      },

      // Client tabs responsive
      clientTabs: {
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        gap: isMobile ? "8px" : "12px",
        marginBottom: isMobile ? "30px" : "40px",
      },

      clientTabButton: {
        padding: isMobile ? "8px 12px" : isTablet ? "10px 16px" : "12px 20px",
        fontSize: isMobile ? "0.8rem" : "0.9rem",
        borderRadius: "25px",
        border: "1px solid #e2e8f0",
        backgroundColor: "white",
        cursor: "pointer",
        transition: "all 0.3s ease",
        display: "flex",
        alignItems: "center",
        gap: isMobile ? "4px" : "8px",
        fontWeight: "600",
      },

      // Clients container responsive
      clientsContainer: {
        marginBottom: isMobile ? "30px" : "40px",
        overflow: "hidden",
      },

      clientLogoWrapper: {
        flex: `0 0 ${100 / getVisibleLogosCount()}%`,
        padding: isMobile ? "0 8px" : "0 12px",
      },

      // Client stats responsive
      clientStats: {
        display: "grid",
        gridTemplateColumns: isMobile
          ? "repeat(2, 1fr)"
          : isTablet
          ? "repeat(2, 1fr)"
          : "repeat(4, 1fr)",
        gap: isMobile ? "20px" : "30px",
        marginTop: isMobile ? "40px" : "60px",
        maxWidth: "800px",
        margin: `${isMobile ? "40px" : "60px"} auto 0`,
      },
      // Gallery grid responsive columns
      galleryGrid: {
        display: "grid",
        gridTemplateColumns: isMobile
          ? "1fr"
          : isTablet
          ? "repeat(2, 1fr)"
          : "repeat(auto-fill, minmax(350px, 1fr))",
        gap: isMobile ? "20px" : isTablet ? "25px" : "30px",
        marginBottom: isMobile ? "40px" : "60px",
      },

      // Section title responsive font sizes
      sectionTitle: {
        fontSize: isMobile ? "1.8rem" : isTablet ? "2.2rem" : "2.8rem",
        fontWeight: "800",
        textAlign: "center",
        marginBottom: isMobile ? "15px" : "20px",
        color: "#2c3e50",
        position: "relative",
      },

      // Section subtitle responsive sizing
      sectionSubtitle: {
        fontSize: isMobile ? "1rem" : isTablet ? "1.1rem" : "1.2rem",
        color: "#64748b",
        lineHeight: "1.6",
        maxWidth: isMobile ? "100%" : "600px",
        margin: "0 auto",
      },

      // Gallery image wrapper sizing
      galleryImageWrapper: {
        width: "100%",
        height: isMobile ? "180px" : isTablet ? "200px" : "220px",
        position: "relative",
        overflow: "hidden",
      },

      // Gallery card content padding
      galleryCardContent: {
        padding: isMobile ? "15px 20px" : "20px 25px",
        flex: 1,
        display: "flex",
        flexDirection: "column",
      },

      // Gallery image titles
      galleryImageTitle: {
        fontSize: isMobile ? "1.1rem" : isTablet ? "1.15rem" : "1.25rem",
        fontWeight: "700",
        color: "#2c3e50",
        marginBottom: isMobile ? "8px" : "10px",
        transition: "color 0.3s ease",
      },

      // Section padding adjustments
      gallerySection: {
        padding: isMobile ? "50px 0" : isTablet ? "70px 0" : "90px 0",
        backgroundColor: "#f1f5f9",
        backgroundImage:
          "radial-gradient(circle at 90% 10%, rgba(22, 59, 162, 0.05) 0%, rgba(22, 59, 162, 0) 50%)",
        position: "relative",
        overflow: "hidden",
      },

      // Testimonial section responsive
      testimonialSection: {
        padding: isMobile ? "50px 0" : isTablet ? "70px 0" : "80px 0",
        backgroundColor: "#f8fafc",
        backgroundImage:
          "linear-gradient(135deg, rgba(22, 59, 162, 0.03) 0%, rgba(22, 59, 162, 0) 70%)",
        position: "relative",
        overflow: "hidden",
      },

      // Testimonial card sizing
      testimonialCard: {
        backgroundColor: "white",
        borderRadius: isMobile ? "12px" : "15px",
        padding: isMobile ? "25px 20px" : isTablet ? "35px 25px" : "40px 30px",
        boxShadow: "0 10px 25px rgba(0, 0, 0, 0.06)",
        position: "relative",
        maxWidth: "800px",
        margin: "0 auto",
      },

      // Testimonial quote text size
      testimonialQuote: {
        fontSize: isMobile ? "1rem" : isTablet ? "1.1rem" : "1.2rem",
        lineHeight: "1.8",
        color: "#4b5563",
        fontStyle: "italic",
        marginBottom: isMobile ? "20px" : "30px",
      },

      // Testimonial navigation arrows
      testimonialArrow: {
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        width: isMobile ? "35px" : "40px",
        height: isMobile ? "35px" : "40px",
        borderRadius: "50%",
        backgroundColor: "white",
        border: "none",
        boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        zIndex: "2",
        color: "#2c3e50",
        transition: "background-color 0.2s ease, transform 0.2s ease",
      },

      // View more button responsive sizing
      viewMoreButton: {
        backgroundColor: "#163ba2",
        color: "white",
        border: "none",
        borderRadius: "30px",
        padding: isMobile ? "12px 25px" : isTablet ? "14px 30px" : "15px 32px",
        fontSize: isMobile ? "1rem" : "1.1rem",
        fontWeight: "600",
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.3s ease",
        boxShadow: "0 8px 20px rgba(22, 59, 162, 0.2)",
      },

      // Lightbox content sizing
      lightboxContent: {
        maxWidth: isMobile ? "95%" : "90%",
        maxHeight: "90%",
        backgroundColor: "white",
        borderRadius: "10px",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
      },

      // Container for proper padding on mobile
      sectionContainer: {
        maxWidth: "1200px",
        margin: "0 auto",
        padding: isMobile ? "0 15px" : "0 20px",
        position: "relative",
        zIndex: 1,
      },

      // Testimonial author image size
      testimonialImage: {
        width: isMobile ? "45px" : isTablet ? "50px" : "60px",
        height: isMobile ? "45px" : isTablet ? "50px" : "60px",
        borderRadius: "50%",
        objectFit: "cover",
        marginRight: isMobile ? "12px" : "15px",
        border: "3px solid rgba(22, 59, 162, 0.15)",
      },
    };
  };

  const responsiveStyles = getResponsiveStyles();

  // Client categories data

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  // Gallery images
  // const galleryImages = [
  //   {
  //     url: PanaromicGlassElevatorHome,
  //     title: "Panoramic Glass Elevator",
  //     description: "Luxury panoramic elevator with 360° palace views",
  //     category: "commercial",
  //     location: "Taj Palace Hotel, Jaipur",
  //   },
  //   {
  //     url: "https://source.unsplash.com/random/600x400/?elevator,modern",
  //     title: "Modern Office Building",
  //     description: "High-speed elevators for corporate technology park",
  //     category: "commercial",
  //     location: "World Trade Park, Jaipur",
  //   },
  //   {
  //     url: "https://source.unsplash.com/random/600x400/?elevator,hotel",
  //     title: "Luxury Hotel Installation",
  //     description: "Custom designed elevators with premium heritage finishes",
  //     category: "commercial",
  //     location: "The Oberoi Amarvilas, Agra",
  //   },
  //   {
  //     url: "https://source.unsplash.com/random/600x400/?elevator,residential",
  //     title: "Residential Complex",
  //     description:
  //       "Quiet and efficient residential elevators with smart features",
  //     category: "residential",
  //     location: "Ashiana Housing, Jaipur",
  //   },
  //   {
  //     url: "https://source.unsplash.com/random/600x400/?elevator,industrial",
  //     title: "Industrial Freight Elevator",
  //     description: "Heavy-duty freight elevators with 5000kg capacity",
  //     category: "industrial",
  //     location: "Sitapura Industrial Area, Jaipur",
  //   },
  //   {
  //     url: "https://source.unsplash.com/random/600x400/?elevator,historic",
  //     title: "Heritage Building Renovation",
  //     description:
  //       "Custom retrofit for historic property with modern safety features",
  //     category: "commercial",
  //     location: "Hawa Mahal Palace Complex, Jaipur",
  //   },
  // ];

  // const filteredGalleryImages =
  //   galleryFilter === "all"
  //     ? galleryImages
  //     : galleryImages.filter((image) => image.category === galleryFilter);

  // Testimonials
  const staticTestimonials = [
    {
      name: "Sarah Johnson",
      company: "Skyline Developers",
      quote:
        "DeeCee Elevators transformed our high-rise building with their state-of-the-art elevator system. The panoramic elevators have become a signature feature that our tenants love.",
      image: "https://randomuser.me/api/portraits/women/32.jpg",
    },
    {
      name: "Michael Chen",
      company: "Golden Gate Properties",
      quote:
        "We've worked exclusively with DeeCee for our last 5 residential projects. Their attention to detail and responsive maintenance team make them our top choice.",
      image: "https://randomuser.me/api/portraits/men/44.jpg",
    },
    {
      name: "Olivia Martinez",
      company: "Premier Hotels Group",
      quote:
        "Our guests frequently comment on the smooth, silent operation of our elevators. DeeCee's technology truly enhances the luxury experience we aim to provide.",
      image: "https://randomuser.me/api/portraits/women/65.jpg",
    },
    {
      name: "Robert Taylor",
      company: "Modern Medical Center",
      quote:
        "In healthcare, reliability is non-negotiable. DeeCee's medical elevators have performed flawlessly since installation, with zero downtime during critical operations.",
      image: "https://randomuser.me/api/portraits/men/22.jpg",
    },
    {
      name: "Emily Wong",
      company: "Sustainable Structures Inc.",
      quote:
        "As architects focused on green building, we appreciate DeeCee's commitment to energy efficiency. Their systems significantly contribute to our LEED certifications.",
      image: "https://randomuser.me/api/portraits/women/47.jpg",
    },
    {
      name: "David Miller",
      company: "Heritage Restoration Projects",
      quote:
        "DeeCee expertly retrofitted elevators in our historic building renovation while preserving architectural integrity. A challenging project executed brilliantly.",
      image: "https://randomuser.me/api/portraits/men/33.jpg",
    },
    {
      name: "Jennifer Adams",
      company: "Luxury Residences Ltd",
      quote:
        "The custom finishes and attention to design details set DeeCee apart. They understand that in luxury properties, elevators are an extension of the overall aesthetic.",
      image: "https://randomuser.me/api/portraits/women/22.jpg",
    },
    {
      name: "Thomas Wilson",
      company: "City Infrastructure Department",
      quote:
        "We've installed DeeCee elevators in multiple public buildings. Their durability in high-traffic environments and accessible features have exceeded our expectations.",
      image: "https://randomuser.me/api/portraits/men/55.jpg",
    },
    {
      name: "Sophia Garcia",
      company: "Vertical Retail Solutions",
      quote:
        "Our shopping mall renovation required complex logistics and phased installation. The DeeCee team coordinated perfectly with minimal disruption to our operations.",
      image: "https://randomuser.me/api/portraits/women/75.jpg",
    },
    {
      name: "James Patel",
      company: "Innovation Tower",
      quote:
        "DeeCee's smart elevator system with destination dispatch has drastically reduced wait times in our office tower, improving both efficiency and tenant satisfaction.",
      image: "https://randomuser.me/api/portraits/men/11.jpg",
    },
  ];

  return (
    <>
      {/* CLIENTS SECTION */}
      <section
        style={{ ...styles.clientsSection, ...responsiveStyles.clientsSection }}
      >
        {/* Background accents */}
        <div style={styles.clientsBgElement1}></div>
        <div style={styles.clientsBgElement2}></div>

        <div
          style={{
            ...styles.sectionContainer,
            ...responsiveStyles.sectionContainer,
          }}
        >
          <div style={styles.titleContainer}>
            <h2
              style={{
                ...styles.sectionTitle,
                ...responsiveStyles.sectionTitle,
              }}
            >
              Our Trusted <span style={styles.highlight}>Clients</span>
            </h2>
            <div style={styles.titleUnderline}>
              <div style={styles.titleUnderlinePrimary}></div>
            </div>
            <p
              style={{
                ...styles.sectionSubtitle,
                ...responsiveStyles.sectionSubtitle,
              }}
            >
              Proud to serve leading brands across various industries with our
              premium elevator solutions
            </p>
          </div>

          {/* Client Category Tabs */}
          <div style={{ ...styles.clientTabs, ...responsiveStyles.clientTabs }}>
            {clientCategories.map((category) => (
              <button
                key={category.id}
                style={{
                  ...styles.clientTabButton,
                  ...(activeClientCategory === category.id
                    ? styles.activeClientTab
                    : {}),
                  ...responsiveStyles.clientTabButton,
                }}
                onClick={() => setActiveClientCategory(category.id)}
              >
                <i className={category.icon} style={styles.tabIcon}></i>
                <span>{category.name}</span>
              </button>
            ))}
          </div>

          {/* Client Logos Carousel */}
          <div
            style={{
              ...styles.clientsContainer,
              ...responsiveStyles.clientsContainer,
            }}
          >
            <AnimatedSection animation="fadeIn" delay={0.2}>
              <div style={styles.clientsCarousel}>
                <div
                  style={{
                    ...styles.clientsTrack,
                    transform: `translateX(-${
                      (currentLogoIndex * 100) / getVisibleLogosCount()
                    }%)`,
                  }}
                >
                  {getCurrentClients().map((client, index) => (
                    <div
                      key={index}
                      style={{
                        ...styles.clientLogoWrapper,
                        ...responsiveStyles.clientLogoWrapper,
                      }}
                    >
                      <div style={styles.clientCard}>
                        <img
                          src={client.logo}
                          alt={client.name}
                          style={styles.clientLogo}
                          loading="lazy"
                        />
                        <div style={styles.clientInfo}>
                          <h4 style={styles.clientName}>{client.name}</h4>
                          <p style={styles.clientLocation}>{client.location}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </AnimatedSection>
          </div>

          {/* Stats Section */}
          <div
            style={{ ...styles.clientStats, ...responsiveStyles.clientStats }}
          >
            <div style={styles.statItem}>
              <div style={styles.statNumber}>700+</div>
              <div style={styles.statLabel}>Happy Clients</div>
            </div>
            <div style={styles.statItem}>
              <div style={styles.statNumber}>5+</div>
              <div style={styles.statLabel}>Cities Served</div>
            </div>

            <div style={styles.statItem}>
              <div style={styles.statNumber}>13+</div>
              <div style={styles.statLabel}>Years of Excellence</div>
            </div>
            <div style={styles.statItem}>
              <div style={styles.statNumber}>24/7</div>
              <div style={styles.statLabel}>Support Available</div>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS SECTION */}
      <section
        style={{
          ...styles.testimonialSection,
          ...responsiveStyles.testimonialSection,
        }}
      >
        <div
          style={{
            ...styles.sectionContainer,
            ...responsiveStyles.sectionContainer,
          }}
        >
          <h2
            style={{ ...styles.sectionTitle, ...responsiveStyles.sectionTitle }}
          >
            What Our <span style={styles.highlight}>Clients Say</span>
          </h2>
          <div style={styles.titleUnderline}>
            <div style={styles.titleUnderlinePrimary}></div>
          </div>
          <p
            style={{
              ...styles.sectionSubtitle,
              ...responsiveStyles.sectionSubtitle,
              marginBottom: "40px",
            }}
          >
            Trusted by businesses and homeowners across India for reliable,
            innovative elevator solutions
          </p>

          {/* Enhanced Google Reviews Card */}
          <div
            style={{
              maxWidth: "840px",
              margin: "0 auto",
              background: "white",
              borderRadius: "16px",
              boxShadow: "0 15px 35px rgba(0, 0, 0, 0.08)",
              overflow: "hidden",
            }}
          >
            {/* Header with Google branding */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "25px 30px",
                borderBottom: "1px solid #f1f5f9",
                flexWrap: "wrap",
                gap: "20px",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  src="https://www.google.com/images/branding/googleg/1x/googleg_standard_color_128dp.png"
                  alt="Google"
                  style={{
                    width: "28px",
                    height: "28px",
                    marginRight: "12px",
                  }}
                />
                <div>
                  <div
                    style={{
                      fontWeight: "700",
                      fontSize: "1.25rem",
                      color: "#2c3e50",
                    }}
                  >
                    DeeCee Elevators
                  </div>
                  <div style={{ fontSize: "0.9rem", color: "#64748b" }}>
                    Google Reviews
                  </div>
                </div>
              </div>

              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ marginRight: "15px", textAlign: "right" }}>
                  <div
                    style={{
                      fontSize: "1.8rem",
                      fontWeight: "800",
                      color: "#2c3e50",
                    }}
                  >
                    4.5
                  </div>
                  <div style={{ fontSize: "0.85rem", color: "#64748b" }}>
                    out of 5
                  </div>
                </div>
                <div style={{ color: "#FBBC05", display: "flex" }}>
                  {[1, 2, 3, 4, 5].map((i) => (
                    <i
                      key={i}
                      className="fas fa-star"
                      style={{ fontSize: "22px" }}
                    ></i>
                  ))}
                </div>
              </div>
            </div>

            {/* Body content */}
            <div style={{ padding: "30px", textAlign: "center" }}>
              <div
                style={{
                  fontSize: "1.1rem",
                  color: "#4b5563",
                  maxWidth: "650px",
                  margin: "0 auto 30px",
                  lineHeight: "1.7",
                }}
              >
                Based on <strong>25+ reviews</strong> from our clients across
                residential, commercial, and industrial projects. Read what our
                customers are saying about their experience with DeeCee
                Elevators.
              </div>

              <div
                style={{
                  display: "flex",
                  gap: "15px",
                  justifyContent: "center",
                  flexWrap: "wrap",
                }}
              >
                <a
                  href="https://maps.app.goo.gl/KYRYeHt6sTM8ruaLA"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "white",
                    border: "1px solid #e2e8f0",
                    color: "#2c3e50",
                    fontWeight: "600",
                    padding: "12px 25px",
                    borderRadius: "30px",
                    textDecoration: "none",
                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.04)",
                    transition: "all 0.3s ease",
                  }}
                >
                  <i
                    className="fab fa-google"
                    style={{ marginRight: "8px", color: "#4285F4" }}
                  ></i>
                  Read All Reviews
                </a>

                <a
                  href="https://maps.app.goo.gl/KYRYeHt6sTM8ruaLA"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#163ba2",
                    color: "white",
                    padding: "12px 25px",
                    borderRadius: "30px",
                    textDecoration: "none",
                    fontWeight: "600",
                    boxShadow: "0 8px 20px rgba(22, 59, 162, 0.2)",
                    transition: "all 0.3s ease",
                  }}
                >
                  Leave a Review
                  <i
                    className="fas fa-external-link-alt"
                    style={{ marginLeft: "8px", fontSize: "0.8rem" }}
                  ></i>
                </a>
              </div>
            </div>

            {/* Footer with highlights */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns:
                  windowWidth <= 576 ? "1fr" : "repeat(3, 1fr)",
                borderTop: "1px solid #f1f5f9",
              }}
            >
              <div
                style={{
                  padding: "22px",
                  textAlign: "center",
                  borderRight:
                    windowWidth <= 576 ? "none" : "1px solid #f1f5f9",
                  borderBottom:
                    windowWidth <= 576 ? "1px solid #f1f5f9" : "none",
                }}
              >
                <div style={{ color: "#163ba2", marginBottom: "8px" }}>
                  <i className="fas fa-clock" style={{ fontSize: "24px" }}></i>
                </div>
                <div
                  style={{
                    fontWeight: "600",
                    color: "#2c3e50",
                    marginBottom: "4px",
                  }}
                >
                  Fast Response
                </div>
                <div style={{ fontSize: "0.85rem", color: "#64748b" }}>
                  24-hour service response
                </div>
              </div>

              <div
                style={{
                  padding: "22px",
                  textAlign: "center",
                  borderRight:
                    windowWidth <= 576 ? "none" : "1px solid #f1f5f9",
                  borderBottom:
                    windowWidth <= 576 ? "1px solid #f1f5f9" : "none",
                }}
              >
                <div style={{ color: "#163ba2", marginBottom: "8px" }}>
                  <i
                    className="fas fa-thumbs-up"
                    style={{ fontSize: "24px" }}
                  ></i>
                </div>
                <div
                  style={{
                    fontWeight: "600",
                    color: "#2c3e50",
                    marginBottom: "4px",
                  }}
                >
                  Client Satisfaction
                </div>
                <div style={{ fontSize: "0.85rem", color: "#64748b" }}>
                  98% satisfaction rate
                </div>
              </div>

              <div
                style={{
                  padding: "22px",
                  textAlign: "center",
                }}
              >
                <div style={{ color: "#163ba2", marginBottom: "8px" }}>
                  <i className="fas fa-sync" style={{ fontSize: "24px" }}></i>
                </div>
                <div
                  style={{
                    fontWeight: "600",
                    color: "#2c3e50",
                    marginBottom: "4px",
                  }}
                >
                  Reliable Service
                </div>
                <div style={{ fontSize: "0.85rem", color: "#64748b" }}>
                  18+ years of excellence
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const styles = {
  // General Section Styles

  clientsSection: {
    padding: "90px 0",
    backgroundColor: "#f1f5f9",
    backgroundImage:
      "radial-gradient(circle at 90% 10%, rgba(22, 59, 162, 0.05) 0%, rgba(22, 59, 162, 0) 50%)",
    position: "relative",
    overflow: "hidden",
  },
  clientsBgElement1: {
    position: "absolute",
    top: "50px",
    right: "-150px",
    width: "300px",
    height: "300px",
    borderRadius: "50%",
    background:
      "radial-gradient(circle, rgba(22, 59, 162, 0.03) 0%, rgba(22, 59, 162, 0) 70%)",
  },
  clientsBgElement2: {
    position: "absolute",
    bottom: "80px",
    left: "-100px",
    width: "400px",
    height: "400px",
    borderRadius: "50%",
    background:
      "radial-gradient(circle, rgba(22, 59, 162, 0.04) 0%, rgba(22, 59, 162, 0) 70%)",
  },
  clientTabs: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "12px",
    marginBottom: "40px",
  },
  clientTabButton: {
    padding: "12px 20px",
    fontSize: "0.9rem",
    borderRadius: "25px",
    border: "1px solid #e2e8f0",
    backgroundColor: "white",
    cursor: "pointer",
    transition: "all 0.3s ease",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontWeight: "600",
    color: "#64748b",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
  },
  activeClientTab: {
    backgroundColor: "#163ba2",
    borderColor: "#163ba2",
    transform: "translateY(-2px)",
    boxShadow: "0 8px 20px rgba(22, 59, 162, 0.2)",
  },
  tabIcon: {
    fontSize: "1rem",
  },
  clientsContainer: {
    marginBottom: "40px",
    overflow: "hidden",
  },
  clientsCarousel: {
    position: "relative",
    overflow: "hidden",
    borderRadius: "12px",
  },
  clientsTrack: {
    display: "flex",
    transition: "transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
    width: "100%",
  },
  clientLogoWrapper: {
    flex: "0 0 25%",
    padding: "0 12px",
  },
  clientCard: {
    backgroundColor: "white",
    borderRadius: "12px",
    padding: "25px 20px",
    boxShadow: "0 8px 25px rgba(0, 0, 0, 0.08)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    transition: "all 0.3s ease",
    cursor: "pointer",
    border: "1px solid rgba(229, 231, 235, 0.5)",
    height: "160px",
    justifyContent: "center",
  },
  clientLogo: {
    width: "100px",
    height: "70px",
    objectFit: "fill",
    marginBottom: "12px",
    borderRadius: "8px",
    // filter: "grayscale(100%)",
    transition: "all 0.3s ease",
  },
  clientInfo: {
    marginTop: "auto",
  },
  clientName: {
    fontSize: "0.9rem",
    fontWeight: "600",
    color: "#2c3e50",
    margin: "0 0 4px 0",
    lineHeight: "1.2",
  },
  clientLocation: {
    fontSize: "0.75rem",
    color: "#64748b",
    margin: "0",
  },
  clientsNavigation: {
    display: "flex",
    justifyContent: "center",
    gap: "8px",
    marginTop: "30px",
  },
  clientsDot: {
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    border: "none",
    backgroundColor: "rgba(22, 59, 162, 0.3)",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  activeClientsDot: {
    backgroundColor: "#163ba2",
    transform: "scale(1.2)",
  },
  clientStats: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "30px",
    marginTop: "60px",
    maxWidth: "800px",
    margin: "60px auto 0 50px",
  },
  statItem: {
    textAlign: "center",
    padding: "25px 20px",
    backgroundColor: "white",
    borderRadius: "12px",
    boxShadow: "0 8px 25px rgba(0, 0, 0, 0.08)",
    transition: "transform 0.3s ease",
    cursor: "default",
  },
  statNumber: {
    fontSize: "2.2rem",
    fontWeight: "800",
    color: "#163ba2",
    marginBottom: "8px",
    display: "block",
  },
  statLabel: {
    fontSize: "0.9rem",
    color: "#64748b",
    fontWeight: "500",
  },
  section: {
    padding: "80px 0",
    backgroundColor: "#f8fafc",
    position: "relative",
    overflow: "hidden",
  },
  backgroundAccent1: {
    position: "absolute",
    top: "-150px",
    right: "-150px",
    width: "1000px",
    height: "400px",
    borderRadius: "50%",
    background:
      "radial-gradient(circle, rgba(22, 59, 162, 0.03) 0%, rgba(22, 59, 162, 0) 70%)",
  },
  backgroundAccent2: {
    position: "absolute",
    bottom: "-100px",
    left: "-100px",
    width: "300px",
    height: "300px",
    borderRadius: "50%",
    background:
      "radial-gradient(circle, rgba(22, 59, 162, 0.05) 0%, rgba(22, 59, 162, 0) 70%)",
  },
  testimonialSection: {
    padding: "80px 0",
    backgroundColor: "#f8fafc",
    backgroundImage:
      "linear-gradient(135deg, rgba(22, 59, 162, 0.03) 0%, rgba(22, 59, 162, 0) 70%)",
    position: "relative",
    overflow: "hidden",
  },
  googleReviewsWidget: {
    maxWidth: "900px",
    margin: "20px auto",
    boxShadow: "0 5px 20px rgba(0, 0, 0, 0.08)",
    borderRadius: "12px",
    overflow: "hidden",
    backgroundColor: "white",
    padding: "20px",
  },
  leaveReviewButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#163ba2",
    color: "white",
    padding: "12px 24px",
    borderRadius: "30px",
    textDecoration: "none",
    fontWeight: "600",
    marginTop: "30px",
    boxShadow: "0 5px 15px rgba(22, 59, 162, 0.2)",
    transition: "all 0.3s ease",
  },
  sectionContainer: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 20px",
    position: "relative",
    zIndex: 1,
  },
  titleContainer: {
    textAlign: "center",
    maxWidth: "700px",
    margin: "0 auto 60px",
  },
  sectionTitle: {
    fontSize: "2.8rem",
    fontWeight: "800",
    textAlign: "center",
    marginBottom: "20px",
    color: "#2c3e50",
    position: "relative",
  },
  titleUnderline: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "25px",
  },
  titleUnderlinePrimary: {
    width: "80px",
    height: "4px",
    backgroundColor: "#163ba2",
    borderRadius: "2px",
  },
  sectionSubtitle: {
    fontSize: "1.2rem",
    color: "#64748b",
    lineHeight: "1.6",
    maxWidth: "600px",
    margin: "0 auto",
  },
  highlight: {
    color: "#163ba2",
    position: "relative",
  },

  // Feature Cards
  featuresContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "30px",
    marginBottom: "50px",
    width: "100%", // Ensure container uses full width
    flexWrap: "wrap", // Allow wrapping on smaller screens
  },
  featureCard: {
    flex: "1 1 300px", // Allow cards to grow and shrink with min width 300px
    maxWidth: "350px", // Maximum width for consistent sizing
    backgroundColor: "white",
    borderRadius: "16px",
    padding: "40px 30px",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    transition: "all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1)",
    cursor: "pointer",
    position: "relative",
    overflow: "hidden",
    height: "100%", // Ensure consistent height
    border: "1px solid rgba(229, 231, 235, 0.5)", // Subtle border
    margin: "0 0 20px 0", // Add some bottom margin for wrapping
  },
  iconBox: {
    width: "90px",
    height: "90px",
    borderRadius: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "25px",
    boxShadow: "0 12px 25px rgba(0, 0, 0, 0.15)",
    position: "relative",
    zIndex: 1,
    transform: "rotate(0deg)", // Initialize for transition
  },
  featureIcon: {
    fontSize: "35px",
    color: "white",
  },
  featureTitle: {
    fontSize: "1.6rem",
    fontWeight: "700",
    marginBottom: "18px",
    color: "#2c3e50",
    transition: "color 0.3s ease",
  },
  featureDivider: {
    width: "50px",
    height: "3px",
    backgroundColor: "#e2e8f0",
    borderRadius: "2px",
    marginBottom: "18px",
    transition: "all 0.3s ease",
  },
  featureDescription: {
    fontSize: "1.05rem",
    lineHeight: "1.7",
    color: "#64748b",
    marginBottom: "25px",
    flex: 1,
  },
  featureFooter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    marginTop: "auto",
  },
  featureLearnMore: {
    fontSize: "0.95rem",
    fontWeight: "600",
    color: "#163ba2",
    marginRight: "8px",
    transition: "all 0.3s ease",
  },
  featureArrow: {
    fontSize: "0.8rem",
    color: "#163ba2",
    transition: "transform 0.3s ease",
    marginLeft: "8px",
  },
  additionalFeaturesWrapper: {
    backgroundColor: "rgba(241, 245, 249, 0.7)",
    borderRadius: "16px",
    padding: "30px",
    boxShadow: "0 5px 20px rgba(0, 0, 0, 0.05)",
    maxWidth: "1000px",
    margin: "0 auto",
    border: "1px solid rgba(229, 231, 235, 0.8)",
  },
  additionalFeaturesTitle: {
    fontSize: "1.4rem",
    fontWeight: "600",
    textAlign: "center",
    marginBottom: "20px",
    color: "#2c3e50",
  },
  additionalFeatures: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "15px",
  },
  additionalFeatureItem: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "white",
    borderRadius: "30px",
    padding: "12px 20px",
    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.05)",
    transition: "all 0.3s ease",
    cursor: "default",
    border: "1px solid rgba(229, 231, 235, 0.5)",
    fontWeight: "500",
  },
  checkIcon: {
    color: "#163ba2",
    marginRight: "10px",
    fontSize: "1.1rem",
  },

  // Gallery Section

  gallerySection: {
    padding: "90px 0",
    backgroundColor: "#f1f5f9",
    backgroundImage:
      "radial-gradient(circle at 90% 10%, rgba(22, 59, 162, 0.05) 0%, rgba(22, 59, 162, 0) 50%)",
    position: "relative",
    overflow: "hidden",
  },
  galleryBgElement1: {
    position: "absolute",
    top: "50px",
    right: "-150px",
    width: "300px",
    height: "300px",
    borderRadius: "50%",
    background:
      "radial-gradient(circle, rgba(22, 59, 162, 0.03) 0%, rgba(22, 59, 162, 0) 70%)",
  },
  galleryBgElement2: {
    position: "absolute",
    bottom: "80px",
    left: "-100px",
    width: "400px",
    height: "400px",
    borderRadius: "50%",
    background:
      "radial-gradient(circle, rgba(22, 59, 162, 0.04) 0%, rgba(22, 59, 162, 0) 70%)",
  },

  galleryGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))",
    gap: "30px",
    marginBottom: "60px",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  galleryFilter: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "15px",
    marginBottom: "30px",
  },
  filterButton: {
    padding: "10px 20px",
    borderRadius: "30px",
    border: "1px solid #e2e8f0",
    backgroundColor: "#fff",
    fontSize: "0.95rem",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
    },
  },
  galleryImageWrapper: {
    width: "100%",
    height: "220px",
    position: "relative",
    overflow: "hidden",
  },
  galleryHoverContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  galleryImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    transition: "transform 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
  },
  galleryHoverOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(22, 59, 162, 0.8)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    opacity: 0,
    transition: "opacity 0.4s ease",
  },
  galleryHoverIcon: {
    color: "white",
    fontSize: "2.2rem",
    marginBottom: "10px",
    transform: "translateY(-10px)",
    transition: "transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
    opacity: 0.9,
  },
  galleryViewDetails: {
    color: "white",
    fontSize: "0.95rem",
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: "1px",
  },
  galleryCardContent: {
    padding: "20px 25px",
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  galleryImageTitle: {
    fontSize: "1.25rem",
    fontWeight: "700",
    color: "#2c3e50",
    marginBottom: "10px",
    transition: "color 0.3s ease",
  },
  galleryCardDescription: {
    fontSize: "0.95rem",
    lineHeight: "1.6",
    color: "#64748b",
    marginBottom: "15px",
    flex: 1,
  },
  galleryCardLocation: {
    fontSize: "0.85rem",
    color: "#64748b",
    marginTop: "auto",
    display: "flex",
    alignItems: "center",
  },
  lightboxMeta: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    marginTop: "15px",
    paddingTop: "15px",
    borderTop: "1px solid #e2e8f0",
  },
  lightboxCategory: {
    fontSize: "0.95rem",
    color: "#64748b",
    display: "flex",
    alignItems: "center",
  },
  viewMoreContainer: {
    textAlign: "center",
    marginTop: "40px",
  },
  viewMoreButton: {
    backgroundColor: "#163ba2",
    color: "white",
    border: "none",
    borderRadius: "30px",
    padding: "16px 35px",
    fontSize: "1.1rem",
    fontWeight: "600",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.3s ease",
    boxShadow: "0 10px 20px rgba(22, 59, 162, 0.25)",
    "&:hover": {
      backgroundColor: "#0f2875",
      transform: "translateY(-5px)",
      boxShadow: "0 15px 30px rgba(22, 59, 162, 0.4)",
    },
  },
  galleryImageDescription: {
    fontSize: "0.85rem",
    color: "rgba(255, 255, 255, 0.8)",
    margin: "5px 0 0",
  },

  // Lightbox styles
  lightbox: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.85)",
    zIndex: 1000,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
  },
  lightboxClose: {
    position: "absolute",
    top: "20px",
    right: "20px",
    backgroundColor: "transparent",
    color: "white",
    border: "none",
    fontSize: "2rem",
    cursor: "pointer",
    zIndex: 1001,
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "scale(1.1) rotate(90deg)",
    },
  },
  lightboxContent: {
    maxWidth: "90%",
    maxHeight: "90%",
    backgroundColor: "white",
    borderRadius: "10px",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
    animation: "fadeIn 0.5s ease forwards",
  },
  lightboxImage: {
    width: "100%",
    maxHeight: "70vh",
    objectFit: "cover",
  },
  lightboxDetails: {
    padding: "20px",
    backgroundColor: "white",
  },
  lightboxTitle: {
    fontSize: "1.5rem",
    fontWeight: "700",
    marginBottom: "10px",
    color: "#2c3e50",
  },
  lightboxDescription: {
    fontSize: "1.05rem",
    lineHeight: "1.5",
    color: "#64748b",
    marginBottom: "10px",
  },
  lightboxLocation: {
    fontSize: "0.95rem",
    color: "#64748b",
    display: "flex",
    alignItems: "center",
    marginTop: "15px",
  },
  galleryItem: {
    position: "relative",
    borderRadius: "12px",
    overflow: "hidden",
    backgroundColor: "white",
    boxShadow: "0 10px 25px rgba(0, 0, 0, 0.08)",
    cursor: "pointer",
    transition: "all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1)",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    "&:hover": {
      transform: "translateY(-10px)",
      boxShadow: "0 20px 40px rgba(0, 0, 0, 0.12)",
    },
    "&:hover .galleryImage": {
      transform: "scale(1.1)",
    },
    "&:hover .galleryHoverOverlay": {
      opacity: 1,
    },
  },
  galleryImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    transition: "transform 0.5s ease",
    "&:hover": {
      transform: "scale(1.05)",
    },
  },
  galleryOverlay: {
    position: "absolute",
    bottom: "0",
    left: "0",
    right: "0",
    padding: "20px",
    background:
      "linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0) 100%)",
    color: "white",
    textAlign: "center",
  },
  galleryImageTitle: {
    fontSize: "1.2rem",
    fontWeight: "600",
    margin: "0",
    textShadow: "0 1px 3px rgba(0,0,0,0.3)",
  },

  // Testimonial Section
  testimonialSliderContainer: {
    position: "relative",
    width: "100%",
    overflow: "hidden",
    padding: "20px 0",
    marginBottom: "40px",
  },
  testimonialSlider: {
    display: "flex",
    transition: "transform 0.5s ease",
    width: "100%",
  },
  testimonialSlide: {
    minWidth: "100%",
    padding: "0 20px",
  },
  testimonialCard: {
    backgroundColor: "white",
    borderRadius: "15px",
    padding: "40px 30px",
    boxShadow: "0 10px 25px rgba(0, 0, 0, 0.06)",
    position: "relative",
    maxWidth: "800px",
    margin: "0 auto",
  },
  testimonialQuoteIcon: {
    fontSize: "2rem",
    color: "rgba(22, 59, 162, 0.15)",
    marginBottom: "20px",
  },
  testimonialQuote: {
    fontSize: "1.2rem",
    lineHeight: "1.8",
    color: "#4b5563",
    fontStyle: "italic",
    marginBottom: "30px",
  },
  testimonialAuthor: {
    display: "flex",
    alignItems: "center",
  },
  testimonialImage: {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    objectFit: "cover",
    marginRight: "15px",
    border: "3px solid rgba(22, 59, 162, 0.15)",
  },
  testimonialInfo: {
    display: "flex",
    flexDirection: "column",
  },
  testimonialName: {
    fontSize: "1.1rem",
    fontWeight: "700",
    margin: "0 0 5px 0",
    color: "#2c3e50",
  },
  testimonialCompany: {
    fontSize: "0.95rem",
    color: "#64748b",
    margin: "0",
  },
  testimonialDots: {
    display: "flex",
    justifyContent: "center",
    gap: "8px",
    marginTop: "30px",
  },
  testimonialDot: {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    border: "none",
    cursor: "pointer",
    transition: "background-color 0.3s ease, transform 0.2s ease",
    "&:hover": {
      transform: "scale(1.2)",
    },
  },
  testimonialArrow: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: "white",
    border: "none",
    boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    zIndex: "2",
    color: "#2c3e50",
    transition: "background-color 0.2s ease, transform 0.2s ease",
    "&:hover": {
      backgroundColor: "#163ba2",
      color: "white",
      transform: "translateY(-50%) scale(1.1)",
    },
  },
  googleReviewsAttribution: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "30px",
  },
  googleBadge: {
    height: "40px",
    marginRight: "10px",
  },
  ratingStars: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "15px",
  },
  starIcon: {
    fontSize: "18px",
    margin: "0 2px",
  },
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "60px 0",
  },
  loadingSpinner: {
    border: "4px solid rgba(22, 59, 162, 0.1)",
    borderLeft: "4px solid #163ba2",
    borderRadius: "50%",
    width: "40px",
    height: "40px",
    animation: "spin 1s linear infinite",
    marginBottom: "20px",
  },
  viewAllReviewsContainer: {
    textAlign: "center",
    marginTop: "30px",
  },
  viewAllReviewsLink: {
    color: "#163ba2",
    fontWeight: "600",
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    transition: "all 0.3s ease",
    "&:hover": {
      textDecoration: "underline",
    },
  },

  // Common button styles
  viewMoreContainer: {
    textAlign: "center",
    marginTop: "40px",
  },
  viewMoreLink: {
    textDecoration: "none",
  },
  viewMoreButton: {
    backgroundColor: "#163ba2",
    color: "white",
    border: "none",
    borderRadius: "30px",
    padding: "15px 32px",
    fontSize: "1.1rem",
    fontWeight: "600",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.3s ease",
    boxShadow: "0 8px 20px rgba(22, 59, 162, 0.2)",
    "&:hover": {
      backgroundColor: "#0f2875",
      transform: "translateY(-5px)",
      boxShadow: "0 12px 25px rgba(22, 59, 162, 0.35)",
    },
  },
  buttonIcon: {
    marginLeft: "10px",
  },

  // Responsive styles
  "@media (max-width: 992px)": {
    sectionTitle: {
      fontSize: "2.4rem",
    },
    featureCard: {
      padding: "30px 25px",
      flex: "1 1 250px",
    },
    galleryGrid: {
      gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
      gap: "25px",
    },
    additionalFeatures: {
      gap: "15px",
    },
    featuresContainer: {
      flexWrap: "nowrap",
      overflowX: "auto",
      justifyContent: "flex-start", // Better alignment when scrolling
      padding: "0 0 20px 0",
      snapType: "x mandatory", // For better scrolling experience
    },
    featureCard: {
      flex: "0 0 280px", // Fixed width on tablets
      scrollSnapAlign: "center",
    },
  },
  "@media (max-width: 820px)": {
    section: {
      padding: "60px 0",
    },
    gallerySection: {
      padding: "60px 0",
    },
    testimonialSection: {
      padding: "60px 0",
    },
    sectionTitle: {
      fontSize: "2rem",
      marginBottom: "40px",
    },
    testimonialQuote: {
      fontSize: "1.1rem",
    },
    testimonialArrow: {
      width: "35px",
      height: "35px",
    },
    galleryGrid: {
      gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
      gap: "20px",
    },
    galleryImageWrapper: {
      height: "180px",
    },
    galleryItem: {
      height: "200px",
    },
    additionalFeatureItem: {
      padding: "8px 15px",
      fontSize: "0.9rem",
    },
    featureCard: {
      flex: "0 0 260px", // Slightly smaller on mobile
    },
    additionalFeatureItem: {
      flex: "0 0 calc(50% - 10px)", // Two per row on smaller screens
    },
  },
  "@media (max-width: 576px)": {
    sectionTitle: {
      fontSize: "1.8rem",
    },
    sectionSubtitle: {
      fontSize: "1rem",
    },
    featuresContainer: {
      gap: "20px",
    },
    featureTitle: {
      fontSize: "1.4rem",
    },
    galleryGrid: {
      gridTemplateColumns: "1fr",
      gap: "25px",
    },
    galleryImageWrapper: {
      height: "200px",
    },
    galleryItem: {
      height: "180px",
    },
    testimonialCard: {
      padding: "30px 20px",
    },
    testimonialQuote: {
      fontSize: "1rem",
    },
    testimonialImage: {
      width: "45px",
      height: "45px",
    },
    additionalFeaturesWrapper: {
      padding: "20px 15px",
    },
    additionalFeatures: {
      flexDirection: "column",
    },
    additionalFeatureItem: {
      width: "100%",
      justifyContent: "flex-start", // Left align on very small screens
    },
  },
};

export default KeyHighlights;
